import gtmCore from 'static/script/app/ui/google-tagmanager-service';
import { logger, Analytics } from 'packages';
import { cache, CACHE_KEYS } from 'tradera-utils/cache';

import actionTypes from './action-types';
import uiActions from '../ui/actions';
import { postWishlistItem } from './api';
import { API_ERRORS } from 'utils/api';
import { WEB_PUSH_MODAL_TYPES } from 'tradera-constants/push-notifications';

const RECENTLY_VIEWED_CACHE_TTL = 30 * 24 * 60 * 60 * 1000;

const add = payload => ({
    type: actionTypes.ADD,
    payload
});

const addRecentlyViewed = item => async (dispatch, getStore) => {
    dispatch({
        type: actionTypes.ADD_RECENTLY_VIEWED,
        payload: item
    });

    const {
        items: { recent }
    } = getStore();

    cache.write(
        CACHE_KEYS.RECENTLY_VIEWED_ITEMS,
        recent,
        RECENTLY_VIEWED_CACHE_TTL
    );
};

const wishlist = itemId => async (dispatch, getStore) => {
    const {
        member: { isLoggedIn, memberId },
        items: { cache },
        page
    } = getStore();
    const item = cache[itemId];
    const { existsInWishList } = item;

    const redirectUrl = window.location.toString();
    const onSignedOutError = () => dispatch(uiActions.signIn({ redirectUrl }));
    if (!isLoggedIn) {
        onSignedOutError();
        return;
    }

    dispatch({
        type: actionTypes.WISHLIST,
        payload: { itemId, exists: !existsInWishList }
    });
    if (!existsInWishList) {
        gtmCore.trackGtmEvent('add-to-wishlist', {
            memberId: memberId,
            itemId: itemId
        });
    }
    Analytics.trackEvent({
        category: 'Wish list',
        action: existsInWishList ? 'remove' : 'add',
        label: page.type
    });
    postWishlistItem(itemId, !existsInWishList)
        .then(response => {
            if (!existsInWishList) {
                dispatch(
                    uiActions.openNotificationOptinModal(
                        WEB_PUSH_MODAL_TYPES.wishlist
                    )
                );
            }
            return response;
        })
        .catch(error => {
            // Restore previous wishlist status on error
            dispatch({
                type: actionTypes.WISHLIST,
                payload: { itemId, exists: existsInWishList }
            });
            switch (error.message) {
                case API_ERRORS.LOGGED_OUT:
                    onSignedOutError();
                    break;
                default:
                    break;
            }
            switch (error.message) {
                case API_ERRORS.CANCELLED:
                case API_ERRORS.NETWORK:
                case API_ERRORS.TIMEOUT:
                case API_ERRORS.VERSION_MISMATCH:
                    break;
                default:
                    logger(error);
                    break;
            }
        });
};

const removeWishList = payload => ({
    type: actionTypes.REMOVE_WISHLIST,
    payload
});

const updateItem = payload => ({
    type: actionTypes.UPDATE_ITEM,
    payload
});

export default {
    add,
    addRecentlyViewed,
    wishlist,
    removeWishList,
    updateItem
};
